module.exports = __webpack_public_path__ + "static/other/hotel_aurora_1.5fcaeb82.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/hotel_aurora_1.json
// module id = 923
// module chunks = 0